<template>
  <div v-if="visivel" class="w3-modal" style="display: block;">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header class="w3-row-padding">
        <span @click="fechar" class="w3-button w3-display-topright">&times;</span>
        <h4 class="texto-vermelho titulo">Grupos de Cliente</h4>
      </header>

      <div
        class="w3-col s12"
        style="max-height: calc(100vh - 320px); min-height: 200px; overflow: auto">

        <div
          class="w3-margin-bottom"
          :key="grupo.grupo_clientes_id"
          v-for="grupo in grupos"
          @click="confirmar(grupo)">

          <div class="w3-col card-item w3-border" style="cursor: pointer;">
            <strong>{{grupo.grupo_clientes_id}}</strong>
            <strong> - </strong>
            <strong class="w3-text-theme">{{grupo.nome}}</strong>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import RGrupoCliente from '@/components/Rest/RGrupoCliente'

  export default {
    name: 'PesquisaGruposClientes',

    components: {
      toastr
    },

    data() {
      return {
        grupos: [],
        visivel: false
      }
    },

    methods: {
      abrir() {
        this.buscarGruposClientes();
        this.visivel = true;
      },

      fechar() {
        this.visivel = false;
      },

      confirmar(grupo) {
        this.$emit('confirmar', grupo);
        this.visivel = false;
      },

      async buscarGruposClientes() {
        try {
          let retorno = await RGrupoCliente.buscarTodosGruposClientes(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.grupos = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch (erro) {
          toastr.error(erro.message);
        }
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  @media (min-width: 993px) {
    .modal-container {
      width: 700px;
    }
  }

  @media (max-width: 768px) {
    .modal-container {
      width: 400px;
    }
  }

  .modal-container {
    border-radius: 12px;
    margin: auto;
    height: auto;
    padding: 20px 20px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    animation: animatezoom 0.6s;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  button {
    background: #9c1d1c;
    color: white;
    padding: 10px;
    border: 0 !important
  }

  .processar-btn {
    margin-top: 10px;
    padding: 5px;
  }

  .selecionado {
    background: #9c1d1c;
    color: white;
  }

  .pesquisar-titulo {
    margin: auto;
    text-align: center;
    cursor: pointer;
    border: #636363 1px solid;
    padding: 10px;
    transition: 0.1s;
    background: #9c1d1c;
    color: white;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 22px;
  }

  .pesquisar-titulo:hover {
    background: white;
    color: black
  }

  .titulo {
    border-bottom: 1px solid #9c1d1c;
    margin-bottom: 20px;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

  @media screen and (max-width: 767px) {
    h2 {
      font-size: 24px;
      margin-bottom:15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaGruposClientes.vue